import { render, staticRenderFns } from "./TableVideoReports.vue?vue&type=template&id=073b670d&scoped=true"
import script from "./TableVideoReports.js?vue&type=script&lang=js&external"
export * from "./TableVideoReports.js?vue&type=script&lang=js&external"
import style0 from "./TableVideoReports.vue?vue&type=style&index=0&id=073b670d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b670d",
  null
  
)

export default component.exports